// /src/pages/CursoDetalle.tsx
import React, { useState } from 'react';
import {
  Box,
  Heading,
  Text,
  Button,
  VStack,
  Badge,
  AspectRatio,
  useToast,
} from '@chakra-ui/react';
import { useParams, useNavigate } from 'react-router-dom';
import { ICurso } from '../types';
import { mockCursos } from '../mocks/cursos';

export const CursoDetalle: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [cursos, setCursos] = useState<ICurso[]>(mockCursos);
  const toast = useToast();

  const curso = cursos.find(c => c.id === id);

  if (!curso) {
    return (
      <Box>
        <Heading>Curso no encontrado</Heading>
        <Button mt={4} onClick={() => navigate('/capacitacion')}>
          Volver a Capacitación
        </Button>
      </Box>
    );
  }

  const handleMarcarCompletado = () => {
    setCursos(prev =>
      prev.map(c =>
        c.id === curso.id ? { ...c, completado: !c.completado } : c
      )
    );

    toast({
      title: curso.completado ? 'Curso marcado como no completado' : 'Curso completado',
      description: curso.completado 
        ? 'Has desmarcado este curso como completado' 
        : '¡Felicitaciones! Has completado este curso',
      status: 'success',
      duration: 3000,
    });
  };

  return (
    <Box>
      <Button mb={4} variant="ghost" onClick={() => navigate('/capacitacion')}>
        ← Volver a Capacitación
      </Button>

      <Box bg="white" p={8} borderRadius="lg" boxShadow="md">
        <VStack align="stretch" spacing={6}>
          <Box>
            {curso.completado && (
              <Badge colorScheme="green" mb={2} fontSize="md">
                ✓ Completado
              </Badge>
            )}
            <Heading size="xl" mb={4}>
              {curso.titulo}
            </Heading>
            <Text fontSize="lg" color="gray.600">
              {curso.descripcion}
            </Text>
          </Box>

          {/* Video embebido */}
          {curso.contenido.includes('youtube.com') || curso.contenido.includes('youtu.be') ? (
            <Box>
              <Heading size="md" mb={4}>
                Contenido del Curso
              </Heading>
              <AspectRatio ratio={16 / 9}>
                <iframe
                  title={curso.titulo}
                  src={curso.contenido}
                  allowFullScreen
                />
              </AspectRatio>
            </Box>
          ) : (
            <Box p={6} bg="gray.50" borderRadius="md">
              <Text>{curso.contenido}</Text>
            </Box>
          )}

          <Box>
            <Button
              colorScheme={curso.completado ? 'gray' : 'green'}
              size="lg"
              w="full"
              onClick={handleMarcarCompletado}
            >
              {curso.completado ? '✓ Marcar como No Completado' : 'Marcar como Completado'}
            </Button>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};
